import { extendTheme } from "@chakra-ui/react";
import { BUTTON_THEME } from "./components/button";
import { CHECKBOX_THEME } from "./components/checkbox";
import { FORM_THEME } from "./components/form";
import { TEXT_THEME } from "./components/text";
import { FONT_THEME } from "./font";

const theme = extendTheme({
  colors: {
    brandPrimary: {
      50: "#F5F7FC",
      100: "#D6E1F2",
      200: "#B2C7E7",
      300: "#87A8D9",
      400: "#6E96D1",
      500: "#4E7EC4",
      600: "#426AA6",
      700: "#324C74",
      800: "#2D4870",
      900: "#203451",
    },
  },
  shadows: {
    outline: "0 0 0 3px var(--chakra-colors-brandPrimary-500)",
  },
  components: {
    Button: BUTTON_THEME,
    Checkbox: CHECKBOX_THEME,
    Text: TEXT_THEME,
    Form: FORM_THEME,
  },
  styles: {
    global: {
      "@font-face": FONT_THEME["@font-face"],
      body: {
        overflowY: "scroll",
        fontFamily: "'Roboto', sans-serif",
      },
      ".renderer h1": {
        fontFamily: "'Cocon', sans-serif",
        fontSize: "2.5rem",
        fontWeight: 300,
        lineHeight: "normal",
        color: "brandPrimary.900",
      },
      ".renderer h2": {
        fontFamily: "'Cocon', sans-serif",
        fontSize: "2rem",
        fontWeight: 300,
        lineHeight: "normal",
        color: "brandPrimary.700",
      },
      ".renderer h3": {
        fontFamily: "'Cocon', sans-serif",
        fontSize: "1.5rem",
        fontWeight: 300,
        lineHeight: "normal",
        color: "#3D557B",
      },
      ".renderer h4": {
        fontFamily: "'Cocon', sans-serif",
        fontSize: "1.375rem",
        fontWeight: 300,
        lineHeight: "normal",
        color: "#3D557B",
      },
      ".renderer h5": {
        fontFamily: "'Cocon', sans-serif",
        fontSize: "1.25rem",
        fontWeight: 300,
        lineHeight: "normal",
        color: "#3D557B",
      },
      ".renderer h6": {
        fontFamily: "'Cocon', sans-serif",
        fontSize: "1.125rem",
        fontWeight: 300,
        lineHeight: "normal",
        color: "#3D557B",
      },
      ".renderer p, .renderer .paragraph, .renderer ul": {
        fontSize: "1rem",
        fontWeight: 400,
        lineHeight: "1.3125rem",
        color: "#3D557B",
        mt: "0.875rem",
        ":first-child": {
          mt: 0,
        },
      },
      ".renderer ul": {
        marginLeft: "1.5rem",
      },
    },
  },
});

export default theme;
